import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import reglas2 from "../assets/avatares/reglas-2.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME4, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			brandTheme
			sidebarTitle="Reglas Dinámica II"
			loading={loading}
			onContinue={handleNext}
			video={reglas2}
		>
			<div className="start-game-rule-block">
				<h3>Sistema económico</h3>
				<p>
					Las <span className="start-game-mark-ok">respuestas correctas</span> os permitirán ganar dinero y aumentar vuestro capital.
					<br />
					Las <span className="start-game-mark-warn">respuestas incorrectas</span> podrán haceros perder parte del presupuesto acumulado.
					<br />
					En algunos retos podréis tener una <strong>segunda oportunidad</strong> para responder, aunque la recompensa será menor que si acertáis a la primera.
				</p>
			</div>
			<div className="start-game-rule-block">
				<p>
					Primer intento:
					<br />
					· Si aciertas son <span className="start-game-mark-ok">+10M €</span> pero si fallas <span className="start-game-mark-warn">-2M €</span>
					<br />
					Segundo intento:
					<br />
					· Si aciertas <span className="start-game-mark-ok">+3M €</span> pero si fallas <span className="start-game-mark-warn">no te resta</span>
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Uso de pistas</h3>
				<p>
					Todas las pruebas incluirán una pista. Podréis utilizarla si lo necesitáis, pero hacerlo tendrá un coste económico para el equipo.
					<br />
					Usar una pista: <span className="start-game-mark-warn">-3M €</span>
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
